import {deepClone, isArray, isNumber, eng2rus, rus2eng, isObject, parseDate, serverTime2clientUserDate, currencyToUiFormat} from "../../funcs";
import Backbone from "backbone";
import RowModel from "./RowModel";
import Filter from "../api/filter/Filter";
import Filter3 from "./filter3/Filter3";

/**
 * Колллекция - кэш, всех строк, загруженных с сервера
 * @extends Backbone.Collection
 */
class RowsCollection extends Backbone.Collection.extend({
    model: RowModel,

    initialize(arr, options) {
        options = options || {};
        this.storage = options.storage;
    }
}) {
    slice() {
        throw new Error("Method not implemented.");
    }
    /**
     * Если известно, что получены ВСЕ строки,
     * то можно использовать этот метод вместо TableApi.get
     * @param  {GetParams} params типичные storage.get параметры, see GetParams
     * columns игнорируется, т.к. известны все поля
     * @return {Backbone.Model[]}        массив моделей,
     */
    getByParams(params) {
        // f.deepClone не клонирует модели, а передает по ссылке,
        // потому что модели это "не простые объекты".
        // -> f.deepClone просто создаст новый массив ссылок на модели
        let models = deepClone(this.models);

        // фильтруем по params.filter
        let filter = params.filter;
        if ( !(filter instanceof Filter) && !(filter instanceof Filter3) ) {
            filter = new Filter(filter);
        }

        // lw-7166
        // В системе используется два формата хранения количетсва денежных
        // средств, а именно 5.00 (ui/front) и 50000 (db/database).
        // ColumnFilter, принимая значения для колонок с типом currency из базы,
        // для вывода преобразует их db -> ui. Поcле того, как пользователь
        // выбрал пункты в дереве фильтра, значения преобразуются ui -> db,
        // и используются в формировании фильтра, который будет отправлен
        // в базу данных. Но есть сценарий, при котором выборка строк
        // производится не через запрос к базе, а из кеша, который хранится
        // на фронте (где количество денежных средств хранится в ui формате).
        // Именно для такого случая и требуется следующий кусок кода. Я им
        // не горжусь, но выбора особого нет.
        // TAG: currency10000
        if ( filter ) {
            for (const key in filter.conditions) {
                const condition = filter.conditions[key];
                const column = this.storage.columns.getByKey(condition.key);

                if ( !column || column.get("type") !== "currency" ) continue;

                if ( condition.value != null ) {
                    condition.value = currencyToUiFormat(
                        condition.value
                    );
                }

                if ( Array.isArray(condition.values) ) {
                    condition.values = condition.values.map(
                        currencyToUiFormat
                    );
                }

                if ( Array.isArray(condition.notValues) ) {
                    condition.notValues = condition.notValues.map(
                        currencyToUiFormat
                    );
                }
            }
        }

        if ( filter ) {
            models = this._filterModelsBy(models, filter, filter instanceof Filter3);
        }

        // фильтруем по params.filter3
        let filter3 = params.filter3;
        if ( !(filter3 instanceof Filter3) ) {
            filter3 = new Filter3(filter3);
        }

        if ( filter3 ) {
            models = this._filterModelsBy(models, filter3, true);
        }

        // фильтруем по params.search
        if ( params.search ) {
            models = this._filterModelsBy(models, this._makeSearchFilter(params.search, params.columns));
        }

        if ( params.distinct ) {
            models = this._distinctBy(models, params.distinct);
        }

        // сортировка
        if ( params.sort ) {
            let sortElems = params.sort.map(function(obj) {
                let keys = Object.keys(obj);
                let key = keys[0];
                return {
                    key,
                    vector: obj[key]
                };
            });

            // сортировка на клиенте не должна отличаться от сортировки на сервере ;)
            if ( isArray(params.columns) ) {
                params.columns.forEach(function(key) {
                    let exists = sortElems.some(function(sortElem) {
                        return sortElem.key == key;
                    });
                    if ( !exists ) {
                        sortElems.push({
                            key,
                            vector: 1
                        });
                    }
                });
            }

            models.sort(function(modelA, modelB) {
                return modelA.mathSortWeight(sortElems, modelB);
            });
        }

        let offset = 0;
        let limit = models.length;

        if ( isNumber(params.limit) && params.limit >= 0 ) {
            limit = params.limit;
        }

        if ( params.offset ) {
            offset = params.offset;
        }

        models = models.slice(offset, offset + limit);

        if ( params.treeParentColumn ) {
            let parentModels = this.findParentModels(
                models,
                params.treeParentColumn
            );
            parentModels.forEach((parentModel) => {
                const existentModel = models.find((model) =>
                    model.id == parentModel.id
                );
                if ( !existentModel ) {
                    models.push(parentModel);
                }
            });
        }

        return models;
    }

    findParentModels(models, parentColumn) {
        let parentModels = {};

        models.forEach((model) => {
            this._forEachModelParent({ parentColumn, model },(parentModel) => {
                parentModels[ parentModel.id ] = parentModel;
            });
        });

        return Object.values(parentModels);
    }

    _forEachModelParent({parentColumn, model}, iteration) {
        let parentId = model.get(parentColumn);
        if ( !parentId ) {
            return;
        }

        let parentModel = this.get(parentId);
        if ( parentModel ) {
            iteration(parentModel);

            this._forEachModelParent({
                parentColumn,
                model: parentModel
            }, iteration);
        }
    }

    _makeSearchFilter(search, columns) {
        let query = ["OR"];
        let column;
        let key;
        let conditions = {};

        if ( !columns ) {
            columns = this.storage.columns;
        } else {
            columns = columns.map(function(key) {
                return this.storage.columns.getByKey(key);
            }, this);
        }

        search = (search + "").toLowerCase();
        for (let i = 0, n = columns.length; i < n; i++) {
            column = columns[i];
            key = column.get("key");

            // original search
            query.push(key + "_$orig");
            conditions[key + "_$orig"] = {
                key,
                type: "contain",
                value: search
            };

            // rbnfq => китай
            query.push(key + "_$rus2eng");
            conditions[key + "_$rus2eng"] = {
                key,
                type: "contain",
                value: rus2eng(search)
            };

            // вщгьут => doumen
            query.push(key + "_$eng2rus");
            conditions[key + "_$eng2rus"] = {
                key,
                type: "contain",
                value: eng2rus(search)
            };
        }

        return new Filter(query, conditions);
    }

    _filterModelsBy(models, filter, isFilter3) {
        if ( !isFilter3 && !filter.checkVersion(filter.serverVersion) ) {
            return models;
        }

        let newModels = [];
        let model;
        for (let i = 0, n = models.length; i < n; i++) {
            model = models[i];

            if ( filter.check(model) ) {
                newModels.push(model);
            }
        }
        return newModels;
    }

    _distinctBy(models, field) {
        let newModels = [];
        let byField = {};

        models.forEach(function(model) {
            let value = model.get(field);
            if ( byField[value] ) {
                return;
            }
            byField[value] = true;
            newModels.push(model);
        });

        return newModels;
    }

    _prepareModel(attrs, options) {
        // !!! options изменяется по ссылке !!!
        if ( !options ) {
            options = {};
        }
        options.storage = this.storage;

        let model = RowsCollection.__super__._prepareModel.call(this, attrs, options);
        model.attributes.entity = this.storage.name;
        return model;
    }

    getModels(rowsOrIds) {
        let models = [];
        let model;
        let i;
        let n;

        if ( rowsOrIds != null ) {
            if ( isObject(rowsOrIds[0]) ) {
                for (i = 0, n = rowsOrIds.length; i < n; i++) {
                    model = this._byId[rowsOrIds[i].id];
                    if ( model ) {
                        models.push(model);
                    }
                }
            } else {
                for (i = 0, n = rowsOrIds.length; i < n; i++) {
                    model = this._byId[rowsOrIds[i]];
                    if ( model ) {
                        models.push(model);
                    }
                }
            }
        }

        return models;
    }

    getUniqueDays({field, filter}) {
        let models = this.getByParams({ filter });
        let days = {};

        models.forEach((model) => {
            let value = model.get(field);
            if ( value == null ) {
                return;
            }

            // truncate to day
            let date = parseDate(value).date;
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);

            let iso = date.toISOString();

            days[iso] = date;
        });

        days = Object.values(days).sort();

        days = days.map((date) =>
            serverTime2clientUserDate(date)
        );

        return days;
    }
}

export default RowsCollection;
